import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'year-picker1',
    template: `
    <div>
        <div class="col-xs-10" style="padding-left:0px;!important;width:63%;">
        <select class="form-control" id="year"  required>
            <option *ngFor="let y of years"  [selected]="yy === y ">{{y}}</option>
        </select>
        </div>
    </div>`
})

export class YearPickerComponent1 implements OnInit {

    years: number[] = [];
    private yy: number;

    ngOnInit() {
        this.getYear();
    }

    getYear() {
        var today = new Date();
        this.yy = today.getFullYear();
        for (var i = (this.yy - 8); i <= this.yy; i++) {
            this.years.push(i);
        }
    }
}


// WEBPACK FOOTER //
// ./src/app/monthpicker/YearPicker1.ts